import {MATH_TYPE, PRIMATIVE_MATH_TYPES} from 'common/report/constants';

export const SUPPORTED_BEHAVIORAL_AGGREGATIONS: MATH_TYPE[] = [
  PRIMATIVE_MATH_TYPES.TOTAL,
  PRIMATIVE_MATH_TYPES.AVERAGE,
  PRIMATIVE_MATH_TYPES.UNIQUE_VALUES,
  PRIMATIVE_MATH_TYPES.MOST_FREQUENT,
  PRIMATIVE_MATH_TYPES.FIRST_VALUE,
  PRIMATIVE_MATH_TYPES.MAX,
  PRIMATIVE_MATH_TYPES.MIN,
];
